var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenCircleTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_865_19544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2069 8.793C16.8169 8.4025 16.1829 8.4025 15.7929 8.793L11.4999 13.0855L9.70687 11.293C9.31687 10.9025 8.68287 10.9025 8.29287 11.293C7.90237 11.6835 7.90237 12.3165 8.29287 12.707L10.7929 15.207C10.9879 15.4025 11.2439 15.5 11.4999 15.5C11.7559 15.5 12.0119 15.4025 12.2069 15.207L17.2069 10.207C17.5974 9.8165 17.5974 9.1835 17.2069 8.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 11C22.448 11 22 11.448 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C14.6845 2 17.2045 3.049 19.0965 4.954C19.485 5.3465 20.1185 5.3485 20.5105 4.959C20.9025 4.57 20.9045 3.937 20.5155 3.545C18.2455 1.259 15.221 0 12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 11.448 23.552 11 23 11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_865_19544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenCircleTickIcon);
export default __webpack_public_path__ + "static/media/BrokenCircleTickIcon.cb2761da8949ddd1fc6e4f4bfd5c7565.svg";
export { ForwardRef as ReactComponent };